/**
 * shadcn Skeleton — loading placeholder with shimmer animation.
 *
 * No headless primitive needed — purely visual Tailwind component.
 * Drop-in replacement for Chakra UI's `<Skeleton>` in table loading states.
 *
 * @see .claude/docs/chakra-to-shadcn-migration.md
 */
import { cn } from '@web-app/lib/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}

export { Skeleton };
